import React from 'react';

import { GenderKeys, HumanReadableGenders } from '../../../../../types/api/Gender';

import Notification from '../Notification/Notification';

interface Props {
    treatmentGender: GenderKeys;
}

/**
 * Notification to the user to say that the treatment the would like is not suitable for their given gender.
 */
const GenderNotification = ({ treatmentGender }: Props) => (
    <Notification>
        Sorry, we are only able to provide this treatment for {HumanReadableGenders[treatmentGender]} patients.
    </Notification>
);

export default GenderNotification;
